module.exports = __webpack_public_path__ + "static/media/Moipone Phajane.afaa032c.jpg";